import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
  compact: PropTypes.bool
};

export default function Logo({ sx, compact = false }) {
  return (
    <RouterLink to="#">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: compact ? 'center' : 'flex-start',
          gap: compact ? 0 : 1.5,
          ...sx
        }}
      >
        <Box
          component="img"
          src={process.env.REACT_APP_LOGO}
          alt="The Clutch"
          sx={{ width: compact ? 36 : 40, height: compact ? 36 : 40, objectFit: 'contain' }}
        />
        {!compact && (
          <Box sx={{ color: '#F3F4F6', fontSize: 18, fontWeight: 300, letterSpacing: '-0.01em', lineHeight: 1.1 }}>
            The <Box component="span" sx={{ fontWeight: 700 }}>Clutch</Box>
          </Box>
        )}
      </Box>
    </RouterLink>
  );
}
